import { HttpInterceptorFn } from '@angular/common/http';
import { AUTH_PUBLIC_ENDPOINTS, AUTH_TOKEN_KEY } from '../../config/api.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isPublicEndpoint = AUTH_PUBLIC_ENDPOINTS.some(endpoint => req.url.startsWith(endpoint));
  if (isPublicEndpoint) {
    return next(req);
  }

  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) {
    return next(req);
  }

  const authedReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(authedReq);
};
